export default __webpack_public_path__ + "static/media/FOO.7195aaa2.png";